<template>
  <div id="generate-time-chart"></div>
</template>

<script>
  import c3 from 'c3'

  export default {
    name: 'generate-time-chart',
    props: {
      value: {
        type: Object,
        default: function () {
          return {}
        }
      }
    },
    data: function () {
      return {
      }
    },
    computed: {
      generateTime () {
        /**
         *
         * 연간 발전량 차트에 쓰일 데이터를 가공합니다.
         * C3 Chart에서 쓰이는 데이터 컬럼 형태입니다.
         * ex) ['test1', 1, 2, 3], ['test2', 1, 2, 3]
         *
         */

        const vm = this
        const data = vm.value.simulate.df_monthly
        let chartColumns = [
          ['x', '1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월']
        ]

        for (let i = 0; i < data.length; i++) {
          const column = []

          // 해당년도를 넣는다.
          column.push(data[i].name)

          // 해당년도와 데이터를 병합하여 차트 컬럼에 넣어준다.
          chartColumns.push(column.concat(data[i].data))
        }

        return chartColumns
      }
    },
    methods: {
      init: function () {
        const vm = this

        // 연간 발전시간 그래프
        let generateTime = {
          bindto: '#generate-time-chart',
          data: {
            x: 'x',
            columns: vm.generateTime
          },
          axis: {
            x: {
              type: 'category',
              tick: {
                fit: true,
                centered: true,
                multiline: false
              }
            },
            y: {
              label: {
                text: '(시간)',
                position: 'inner-top'
              }
            }
          },
          point: {
            r: 3
          },
          grid: {
            y: {
              show: true
            }
          },
          color: {
            pattern: ['#164663', '#17626e', '#098ea3', '#04b0af', '#22d1ba', '#81edea', '#87cbf7', '#8697e0', '#ac95f7', '#d39ded']
          },
          tooltip: {
            format: {
              value: function (value) {
                // 소수점 2자리까지만 출력
                return value.toFixed(2)
              }
            }
          }
        }

        // 연간 발전시간 차트 초기화
        c3.generate(generateTime)
      },
      flush: function () {
      }
    },
    created: function () {
    },
    mounted: function () {
      this.init()
    }
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/chart/GenerateTimeChart.vue